require('jssocials');
require('../../js/layouts/plugins/jssocials.init.js');
window.IpixJsSocials = require('../../js/layouts/components/jssocials.js');